// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState(() => {
    const savedAuth = localStorage.getItem("authState");
    return savedAuth
      ? JSON.parse(savedAuth)
      : {
          sessionId: null,
          login: false,
          profile: {},
          auth: {},
          isLoading: false,
        };
  });

  // อัปเดต localStorage เมื่อ authState เปลี่ยน
  useEffect(() => {
    console.log("Saving AuthState to localStorage:", authState);
    localStorage.setItem("authState", JSON.stringify(authState));
  }, [authState]);

  const login = (data) => {
    console.log("Logging in with:", data);
    setAuthState({ ...authState, ...data, isLoading: false });
  };

  const logout = () => {
    console.log("Logging out");
    setAuthState({
      sessionId: null,
      login: false,
      profile: {},
      auth: {},
      isLoading: false,
    });
  };

  return (
    <AuthContext.Provider value={{ ...authState, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);